import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './DeleteAccountModal.module.scss'
import axios from 'axios'
import { useAuthStatus } from '../../../utils'

export function DeleteAccountModal({ isOpen, onClose }) {
	const [step, setStep] = useState('confirm') // 'confirm' or 'completed'
	const navigate = useNavigate()
	const [auth, handleLogout] = useAuthStatus()
	const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT
	const token = localStorage.getItem('token')?.replace(/"/g, '')

	if (!isOpen) return null

	const handleCancel = () => {
		onClose()
		setStep('confirm')
	}

	const handleConfirm = async () => {
		try {
			console.log('userid:', auth.user.id)
			handleLogout()
			await axios.patch(`${API_ENDPOINT}/users/${auth.user?.id}/delete`, {
				headers: { Authorization: `Bearer ${token}` },
			})
		} catch (error) {
			console.error('회원 탈퇴 요청 실패:', error)
		}
		setStep('completed')
	}

	const handleCompleted = () => {
		navigate('/') // 비회원 랜딩 페이지로 이동
	}

	return (
		<div className={styles.overlay}>
			<div className={styles.modal}>
				{step === 'confirm' ? (
					<div>
						<div className={styles.title}>아쉽지만, 저희와 작별하시나요?</div>
						<div className={styles.subtitle}>
							<div>회원 탈퇴 시, 더 이상 서비스를 이용할 수 없게 돼요.</div>
							<div> 정말 탈퇴하시겠어요?</div>
						</div>
						<div className={styles.buttonGroup}>
							<button className={styles.cancelButton} onClick={handleConfirm}>
								<span className={styles.btnContent}>탈퇴하기</span>
							</button>
							<button className={styles.firstConfirmButton} onClick={handleCancel}>
								<span className={styles.btnContent}>회원 유지하기</span>
							</button>
						</div>
					</div>
				) : (
					<div>
						<div className={styles.title}>탈퇴 처리가 완료되었어요</div>
						<div className={styles.subtitle}>
							<div>그동안 저희 스포이음을 이용해주셔서 감사합니다.</div>{' '}
							<div>언제든 필요하시면 다시 찾아주세요.</div>
						</div>
						<button className={styles.secondConfirmButton} onClick={handleCompleted}>
							확인
						</button>
					</div>
				)}
			</div>
		</div>
	)
}
